import React, { useEffect, useRef } from 'react';
import { missionSets } from '../../data/missions';
import './MissionsModal.css';

const MissionsModal = ({ open, onClose, activeMissionId, onSelectMission }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    dialogRef.current?.focus();
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="missions-modal-overlay" onClick={onClose} role="presentation">
      <div
        ref={dialogRef}
        id="missions-modal"
        className="missions-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="missions-modal-title"
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="missions-modal-header">
          <div className="missions-modal-heading">
            <h2 id="missions-modal-title" className="missions-modal-title">
              Today I will focus on:
            </h2>
            <p className="missions-modal-subtitle">
              Pick one mini mission. Your choice stays highlighted until you change it.
            </p>
          </div>
          <button
            type="button"
            className="missions-modal-close"
            onClick={onClose}
            aria-label="Close missions"
          >
            ×
          </button>
        </div>

        <div className="missions-modal-body">
          {missionSets.map((set) => (
            <section key={set.id} className="missions-set">
              <h3 className="missions-set-title">{set.title}</h3>
              <ol className="missions-list">
                {set.missions.map((mission, index) => {
                  const isActive = activeMissionId === mission.id;
                  return (
                    <li key={mission.id}>
                      <button
                        type="button"
                        className={`missions-item${isActive ? ' is-active' : ''}`}
                        aria-pressed={isActive}
                        onClick={() => onSelectMission(mission.id)}
                      >
                        <span className="missions-item-number">{index + 1}</span>
                        <span className="missions-item-copy">
                          <span className="missions-item-title">{mission.title}</span>
                          <span className="missions-item-body">{mission.body}</span>
                        </span>
                      </button>
                    </li>
                  );
                })}
              </ol>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MissionsModal;
